import React, { useContext } from 'react';
import styled from 'styled-components';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';
import type { HandleFieldUpdateType, AdvancedOptionsContextType } from '../common/utils/types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const StyledAdditionalFields = styled(AdditionalFields)`
  margin: 0 0 35px;
`;

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { mimecastThrottleEnabled, mimecastStoreFullMessage } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <StyledAdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <Input
        id="mimecastThrottleEnabled"
        type="checkbox"
        value="enable-throttling"
        defaultChecked={mimecastThrottleEnabled?.value}
        onChange={onChange}
        label="Enable Throttling"
        help="If enabled, no new messages will be read from this input until the server catches up with its message load. This is typically useful for inputs reading from files or message queue systems like AMQP or Kafka. If you regularly poll an external system, e.g. via HTTP, you normally want to leave this disabled."
      />

      <Input
        id="mimecastStoreFullMessage"
        type="checkbox"
        value="enable-storeFullMessage"
        defaultChecked={mimecastStoreFullMessage?.value}
        onChange={onChange}
        label="Store Full Message"
        help="Store the full original Mimecast log record message as full_message?"
      />
    </StyledAdditionalFields>
  );
};

export default FormAdvancedOptions;
